import * as PIXI from "pixi.js";
import Game from "../Game";
import YellowCursorCircle from "../entities/YellowCursorCircle";
import Logo from "../entities/Logo";


export default class Layers extends PIXI.Container {
  static instance: Layers;
  private Game = Game.getInstance();
  BottomUnder: BaseLayer;
  Bottom: BaseLayer;
  Middle: BaseLayer;
  TopUnder: BaseLayer;
  Top: BaseLayer;
  Info: BaseLayer;
  UI: BaseLayer;
  UITop: BaseLayer;
  VideoMode: BaseLayer;

  constructor() {
    super();
    if (!Layers.instance) {
      Layers.instance = this;
    }
    this.BottomUnder = new BaseLayer();
    this.Bottom = new BaseLayer();
    this.Middle = new BaseLayer();
    this.TopUnder = new BaseLayer();
    this.Top = new BaseLayer();
    this.Info = new BaseLayer();
    this.UI = new BaseLayer();
    this.UITop = new BaseLayer();
    this.VideoMode = new BaseLayer();
    this.UI.interactive = true;
    this.UITop.interactive = true;

    this.checkVideoMode();
    this.addToStage();
  }
  private addToStage = () => this.Game.stage.addChild(this);
  static getInstance = () => Layers.instance;

  private checkVideoMode() {
    const params = new URLSearchParams(window.location.search);
    const videoMode = params.get("videomode");
    if (videoMode) {
      new Logo();
      new YellowCursorCircle();
    }
  }
}


class BaseLayer extends PIXI.Container {
  Layers = Layers.getInstance();
  constructor() {
    super();
    this.addToLayers();
  }
  private addToLayers = () => this.Layers.addChild(this);
}